document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  if (toggle) {
    toggle.addEventListener('click', () => {
      const open = document.body.classList.toggle('menu-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }
  document.querySelectorAll('[data-localization-select]').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const productLinks = document.querySelectorAll(
    '.nav__item > .nav__link'
  );

  productLinks.forEach(function (link) {
    const submenu = link.nextElementSibling;

    if (!submenu || !submenu.classList.contains('nav__dropdown')) {
      return;
    }

    link.setAttribute('aria-expanded', 'false');

    link.addEventListener('click', function (event) {
      if (window.matchMedia('(max-width: 1100px)').matches) {
        event.preventDefault();

        const menuItem = link.closest('.nav__item');
        const isOpen = menuItem.classList.toggle('submenu-open');

        link.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
    });
  });
});